import { render, staticRenderFns } from "./AddStaffToGroupModal.vue?vue&type=template&id=0856936c&"
import script from "./AddStaffToGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddStaffToGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports